import React, { useEffect, useRef, useState } from 'react';
type FadeUpProps = {
  children: React.ReactNode;
  className?: string;
  as?: 'div' | 'section' | 'footer';
};
export function FadeUp({
  children,
  className = '',
  as = 'div'
}: FadeUpProps) {
  const ref = useRef<HTMLElement | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  const Tag = as as React.ElementType;
  return <Tag ref={ref as never} className={`fade-up ${className}`} style={{
    opacity: visible ? 1 : 0,
    transform: visible ? 'translateY(0)' : 'translateY(20px)',
    transitionProperty: 'opacity, transform',
    transitionDuration: '0.5s',
    transitionTimingFunction: 'cubic-bezier(0.23, 1, 0.32, 1)'
  }} data-id="element-14" data-mp="22wj21odu53dg">
      {children}
    </Tag>;
}